import { cn } from "@/lib/utils";
import { useState } from "react";

import { smallerClosingCross } from "../../../designSystemIcons";

type Props = {
  label?: string;
  options: Option[];
  onSelectOption: (index: number) => void;
  onClear: () => void;
  smallWidth?: boolean;
  newDesign?: boolean;
};

type Option = {
  label: string;
  selected: boolean;
};

// Custom Filter component for when the filter is one of multiple options
export const SelectorFilter = ({
  label,
  onClear,
  options,
  onSelectOption,
  smallWidth,
  newDesign,
}: Props) => {
  const [hover, setHover] = useState(false);

  return (
    <div
      className="flex justify-between p-1 gap-x-1 w-full"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      {label && (
        <div className="flex justify-between w-1/2">
          <p className="text-xs font-medium text-gray-300">{label}</p>
          {options.some(({ selected }) => selected) && hover && !smallWidth && (
            <button
              className="flex items-center justify-center shrink-0 w-4 h-4 my-auto rounded-full bg-primary-red fill-white"
              onClick={(e) => {
                onClear();
                e.stopPropagation();
              }}
            >
              {smallerClosingCross}
            </button>
          )}
        </div>
      )}
      <div className={cn("flex gap-x-1", smallWidth ? "w-[54px]" : "w-full")}>
        {options.map(({ label, selected }, i) => (
          <button
            key={label}
            className={
              newDesign
                ? cn(
                    "w-full px-1 bg-action-tertiary rounded-sm mobile:text-sm",
                    selected
                      ? "bg-action-tertiary-active text-dark-primary"
                      : "hover:bg-action-tertiary-hover hover:text-dark-secondary ",
                  )
                : cn(
                    "w-full text-xs rounded-sm px-[5px] text-center my-auto h-5",
                    selected
                      ? "bg-primary-dark-blue text-white"
                      : "bg-black/30 touch-device:hover:text-gray-600 text-gray-400 touch-device:hover:bg-gray-400",
                  )
            }
            onClick={() => onSelectOption(i)}
          >
            {label}
          </button>
        ))}
      </div>
    </div>
  );
};
